import React, { useState } from 'react';
import './Quote.css';
import bannerImg from '../assets/color-1867371_1920.jpg';

function Quote() {
  const [formData, setFormData] = useState({
    company: '',
    contact: '',
    phone: '',
    email: '',
    message: '',
  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess(false);

    const body = {
      api_key: 'api-359669F6DC224EFD865964D917E622E6',
      to: ['info@peelsnativeplants.com'],
      sender: 'mail@peelsnativeplants.com',
      reply_to: 'info@peelsnativeplants.com',
      subject: 'New Plant Quote Request',
      text_body: `
Company: ${formData.company}
Contact Person: ${formData.contact}
Phone: ${formData.phone}
Email: ${formData.email}
Message: ${formData.message}
      `.trim(),
    };

    try {
      const response = await fetch('https://api.smtp2go.com/v3/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (data.data && data.data.succeeded) {
        setSuccess(true);
        setFormData({ company: '', contact: '', phone: '', email: '', message: '' });
      } else {
        alert('Error submitting quote. Please try again.');
      }
    } catch (error) {
      console.error(error);
      alert('Error submitting quote. Please check your internet connection.');
    }

    setSubmitting(false);
  };

  return (
    <div className="quote-page">
      {/* Banner */}
      <div className="quote-banner" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="container">
          <div className="quote-banner-content">
            <h1>Get in touch</h1>
            <p>We're always here to help</p>
          </div>
        </div>
      </div>

      {/* Quote Form */}
      <div className="quote-form-section">
        <div className="container">
          <h2>Get A Plants Quote</h2>
          <form className="quote-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="e.g. GreenGrow Landscaping"
                required
              />
            </div>

            <div className="form-group">
              <label>Contact Person</label>
              <input
                type="text"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                placeholder="e.g. John Smith"
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="e.g. 604-217-1351"
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="e.g. example@domain.com"
                required
              />
            </div>

            <div className="form-group">
              <label>Plant Name, Quantity, Size</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="e.g. 20x Red Maple 10-gallon, 30x Blue Spruce Plugs"
                required
              />
            </div>

            <button type="submit" className="quote-submit-button" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit Quote'}
            </button>

            {success && (
              <div className="quote-success-box">
                ✅ Quote submitted successfully!
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Quote;
